/* eslint-disable no-undef */
import { Grid } from "@mui/material";
import { RouteComponentProps } from "@reach/router";
import gql from "graphql-tag";
import { useQuery } from "react-apollo";
import { ToastContainer } from "react-toastify";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import TLADatacenterDetails from "../../components/TLA/TLADatacenterDetails";
import { GetDatacenter, GetDatacenterVariables } from "./__generated__/GetDatacenter";

interface Props extends RouteComponentProps {
    path?: string;
    id?: string;
}

export const GET_DATACENTER = gql`
    query GetDatacenter($id: ID!) {
        datacenter(id: $id) {
            id
            name
            tla {
                id
                name
                description
                domain
                hostId
                provider
                region
                labels
                override
                http3
                tls
                fqdn {
                    origins
                    ingest
                }
                letsEncrypt
                certificates {
                    name
                    source
                }
                deviceContexts {
                    id
                    name
                    labels
                    serial
                    capacity
                    privateId
                    privateIp
                    joinToken
                    override
                    isCluster
                    state
                    description
                    sdiInputs {
                        name
                        deviceNumber
                        persistentId
                    }
                }
                installContexts {
                    id
                    name
                    state
                    description
                    disableVaultSSH
                    upgradeDocker
                    labels
                    nodeLabels
                    command
                    privateId
                    privateCIDR
                    securityToken
                }
            }
            organizations {
                organizationId
                name
            }
            channels {
                channelId
                channelStatus
                organization {
                    organizationId
                    name
                }
                metadata {
                    name
                }
            }
        }
    }
`;

// eslint-disable-next-line no-empty-pattern
export default function TLADatacenter({ id }: Props) {
    const { data } = useQuery<GetDatacenter, GetDatacenterVariables>(GET_DATACENTER, {
        variables: {
            id: id!,
        },
    });

    return (
        <>
            <Grid container spacing={{ xs: 5, md: 6 }}>
                <Grid item xs={12}>
                    <SectionTitle title={`Data center ${data?.datacenter?.id ?? ""}`} align={"left"} showBottomBorder />
                    {data?.datacenter && <TLADatacenterDetails datacenter={data.datacenter} />}
                </Grid>
            </Grid>
            <ToastContainer />
        </>
    );
}
